import { render, staticRenderFns } from "./icon-grid-with-hero-text-conven-feet.vue?vue&type=template&id=19c1cdec&scoped=true&"
import script from "./icon-grid-with-hero-text-conven-feet.vue?vue&type=script&lang=js&"
export * from "./icon-grid-with-hero-text-conven-feet.vue?vue&type=script&lang=js&"
import style0 from "./icon-grid-with-hero-text-conven-feet.vue?vue&type=style&index=0&id=19c1cdec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c1cdec",
  null
  
)

export default component.exports